export const GET_JOB_DETAILS_REQUEST = "GET_JOB_DETAILS_REQUEST";

export const SAVE_BASIC_JOB_DETAILS_REQUEST =
  "SAVE_BASIC_JOB_DETAILS_REQUEST";
export const SAVE_JOB_DETAILS_SUCCESS = "SAVE_JOB_DETAILS_SUCCESS";


export const GET_SKILS_DROPDOWN_REQUEST = "GET_SKILS_DROPDOWN_REQUEST";

export const GET_BENFITS_DROPDOWN_REQUEST = "GET_BENFITS_DROPDOWN_REQUEST";
export const GET_SPECIALZATION_DROPDOWN_REQUEST = "GET_SPECIALZATION_DROPDOWN_REQUEST";
export const GET_JOB_CITY_DROPDOWN_REQUEST = "GET_JOB_CITY_DROPDOWN_REQUEST";
export const GET_FOCUS_AREA_DROPDOWN_REQUEST = "GET_FOCUS_AREA_DROPDOWN_REQUEST";
export const GET_SOFT_SKILLS_DROPDOWN_REQUEST = "GET_SOFT_SKILLS_DROPDOWN_REQUEST";
export const GET_PAY_COMMISSION_DROPDOWN_REQUEST = "GET_PAY_COMMISSION_DROPDOWN_REQUEST";
export const GET_ROLETIRS_DROPDOWN_REQUEST = "GET_ROLETIRS_DROPDOWN_REQUEST";
export const VIEW_JOB_DETAILS_STATUS_REQUEST = "VIEW_JOB_DETAILS_STATUS_REQUEST";
export const SAVE_APPLY_JOBS_REQUEST = "SAVE_APPLY_JOBS_REQUEST";


export const GET_EQUIPMENT_PROFICIENCY_DROPDOWN_REQUEST = "GET_EQUIPMENT_PROFICIENCY_DROPDOWN_REQUEST";

export const SAVE_UPDATE_JOB_STATUS_REQUEST = "SAVE_UPDATE_JOB_STATUS_REQUEST";


export const GET_ACTIVE_ADDRESSES_DROPDOWN_REQUEST = "GET_ACTIVE_ADDRESSES_DROPDOWN_REQUEST";

export const GET_HOSPITAL_BASIC_INFO_REQUEST = "GET_HOSPITAL_BASIC_INFO_REQUEST";
export const GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST = "GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST";
export const GET_HOSPITAL_OWNERSHIP_INFO_REQUEST = "GET_HOSPITAL_OWNERSHIP_INFO_REQUEST";
export const GET_HOSPITAL_OTHER_DETAILS_REQUEST = "GET_HOSPITAL_OTHER_DETAILS_REQUEST";
export const GET_HOSPITAL_HOSTEL_DETAILS_REQUEST = "GET_HOSPITAL_HOSTEL_DETAILS_REQUEST";
export const GET_HOSPITAL_SOCIAL_INFO_REQUEST = "GET_HOSPITAL_SOCIAL_INFO_REQUEST";
export const GET_HOSPITAL_DOCUMENT_INFO_REQUEST = "GET_HOSPITAL_DOCUMENT_INFO_REQUEST";